
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("3U5pN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $15d7eda943b9fd1c$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $ghmTa = parcelRequire("ghmTa");

var $5LjUB = parcelRequire("5LjUB");

var $bEEBX = parcelRequire("bEEBX");

var $gwaiZ = parcelRequire("gwaiZ");

var $dvPqk = parcelRequire("dvPqk");

var $8kt8E = parcelRequire("8kt8E");

var $aRSTV = parcelRequire("aRSTV");

var $5OqMf = parcelRequire("5OqMf");

var $3kQAm = parcelRequire("3kQAm");

var $25aT1 = parcelRequire("25aT1");

var $jlTfJ = parcelRequire("jlTfJ");

var $biFcX = parcelRequire("biFcX");

var $bZiDo = parcelRequire("bZiDo");

var $hFzdq = parcelRequire("hFzdq");

var $izjX7 = parcelRequire("izjX7");

var $gtsdT = parcelRequire("gtsdT");

var $cLLe3 = parcelRequire("cLLe3");

var $9Vrue = parcelRequire("9Vrue");

var $fGZ1g = parcelRequire("fGZ1g");

var $cLfby = parcelRequire("cLfby");

var $bDXRc = parcelRequire("bDXRc");

var $dH8nW = parcelRequire("dH8nW");

var $913nc = parcelRequire("913nc");

var $liXOE = parcelRequire("liXOE");

var $luszM = parcelRequire("luszM");

var $isIf6 = parcelRequire("isIf6");
const $15d7eda943b9fd1c$var$searchDomains = (0, $isIf6.default).searchConfig.searchDomains;
const $15d7eda943b9fd1c$var$productSearchDomain = $15d7eda943b9fd1c$var$searchDomains.find((searchDomain)=>searchDomain.type === "product");
const $15d7eda943b9fd1c$var$algoliaIndex = $15d7eda943b9fd1c$var$productSearchDomain?.indexName || "";
const $15d7eda943b9fd1c$var$ProductListPage = ({ cat2: cat2, cat3: cat3 })=>{
    const [visibleCount, setVisibleCount] = (0, $dvPqk.useState)(60);
    const cat1 = "produkter";
    const urlKeys = {
        cat1: cat1
    };
    if (cat2) urlKeys.cat2 = (0, $5OqMf.stripPossibleHtmlExtension)(cat2);
    if (cat3) urlKeys.cat3 = (0, $5OqMf.stripPossibleHtmlExtension)(cat3);
    const catKey = `${cat1}-${cat2}-${cat3}`;
    (0, $dvPqk.useEffect)(()=>{
        (0, $bZiDo.default).clearFilter();
    }, [
        catKey
    ]);
    let catInfo = null;
    try {
        catInfo = (0, $25aT1.default).categories.length > 0 ? (0, $25aT1.default).findCategoryByUrlKey(urlKeys) : null;
    } catch (error) {
        (0, $gtsdT.logger).error("products", "Could not find category page.", error, {
            urlKeys: urlKeys
        });
    }
    const skus = !(0, $bEEBX.default)(catInfo) && !(0, $bEEBX.default)(catInfo.category) ? catInfo.category.skus : [];
    const variant = catInfo?.category.url_key || "";
    const products = (0, $dvPqk.useMemo)(()=>(0, $bZiDo.default).resolveSkus(skus), [
        skus
    ]);
    const sortedProducts = (0, $dvPqk.useMemo)(()=>(0, $luszM.prioritizeAgreementAssortment)(products, (0, $biFcX.default).prioritizeAgreementAssortment), [
        products,
        (0, $biFcX.default).prioritizeAgreementAssortment
    ]);
    const currentProducts = (0, $dvPqk.useMemo)(()=>(0, $bZiDo.default).filterWithActiveFilters(sortedProducts), [
        sortedProducts,
        (0, $bZiDo.default).activeFilters
    ]);
    const richText = (0, $jlTfJ.default).getRichTextForProductCategory(`${(0, $5OqMf.stripPossibleHtmlExtension)(cat2 || "")}${cat3 ? `/${(0, $5OqMf.stripPossibleHtmlExtension)(cat3)}` : ""}`);
    const visibleSlice = currentProducts.slice(0, visibleCount);
    // Used by Algolia to support Personalization, Recommendations, A/B testing and more
    const callbacks = {
        click: (product)=>{
            (0, $hFzdq.default).reportAlgoliaClick(product.sku, $15d7eda943b9fd1c$var$algoliaIndex);
        },
        addToCart: (product)=>{
            (0, $hFzdq.default).reportAlgoliaAddToCart(product.sku, $15d7eda943b9fd1c$var$algoliaIndex);
        }
    };
    if ((0, $25aT1.default).categories.length === 0) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9Vrue.default), {});
    if ((0, $bEEBX.default)(catInfo) || !(0, $bEEBX.default)(catInfo) && (0, $bEEBX.default)(catInfo.category)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fGZ1g.default), {});
    const breadcrumbItems = catInfo.levels.map((c)=>({
            label: (0, $5OqMf.titleCase)(c.name),
            href: c.fullUrl,
            as: (0, $8kt8E.Link)
        }));
    const isSideMenu = (0, $biFcX.default).navigationTestVariant === "sidemenu";
    const isTopMenu = (0, $biFcX.default).navigationTestVariant === "topmenu";
    const isMegaMenu = !isSideMenu && !isTopMenu;
    const productListContainerStyle = (0, $izjX7.cn)("tw-flex-auto", {
        "tw-px-2": isMegaMenu
    });
    const productListHeader = !isMegaMenu ? (0, $5OqMf.titleCase)(catInfo.category.name) : catInfo.category.name;
    const rootCategory = (0, $25aT1.default).categories[0];
    const productCountText = currentProducts.length === 1 ? "1 produkt" : `${currentProducts.length} produkter`;
    const level1CategoryId = catInfo.levels[1]?.id || "";
    const bodyContainerStyle = (0, $izjX7.cn)("tw-flex tw-flex-col", {
        "lg:tw-flex-row": isMegaMenu,
        "md:tw-flex-row": isSideMenu
    });
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            isMegaMenu && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: "tw-mb-6",
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $ghmTa.Breadcrumbs), {
                    items: breadcrumbItems
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: bodyContainerStyle,
                children: [
                    isMegaMenu && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "tw-w-52 tw-shrink-0",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $bDXRc.default), {
                            products: products,
                            variant: variant,
                            numberOfProducts: currentProducts.length
                        })
                    }),
                    isSideMenu && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "tw-w-64 tw-shrink-0 tw-hidden md:tw-block",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $913nc.default), {
                            includeAll: true,
                            categoryInfo: rootCategory,
                            currentCategoryId: level1CategoryId
                        })
                    }),
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: productListContainerStyle,
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                className: "tw-flex tw-justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("h2", {
                                        children: productListHeader
                                    }),
                                    !!isMegaMenu && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: "tw-mb-2 tw-text-nowrap tw-text-sm",
                                        children: productCountText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("nav", {
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)((0, $liXOE.default), {
                                        catInfo: catInfo
                                    }),
                                    richText && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                        className: "product-category-content tw-my-4",
                                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLfby.default), {
                                            document: richText,
                                            context: "category-content"
                                        })
                                    }),
                                    !isMegaMenu && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $dH8nW.default), {
                                        products: sortedProducts,
                                        categoryKey: catInfo.category.url_key
                                    })
                                ]
                            }),
                            !isMegaMenu && /*#__PURE__*/ (0, $7YWoO.jsxs)("h3", {
                                className: "tw-text-h5",
                                children: [
                                    productListHeader,
                                    " (",
                                    currentProducts.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3kQAm.default), {
                                products: visibleSlice,
                                callbacks: callbacks,
                                listName: `Kategoriside: ${catInfo.category.name}`,
                                listType: (0, $aRSTV.LIST_TYPE).CATEGORY,
                                context: "category"
                            }),
                            (0, $5LjUB.default)(visibleSlice) && (0, $gwaiZ.default)((0, $bZiDo.default).activeFilters) > 1 && /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "tw-mt-1",
                                children: "Vi fant dessverre ingen produkter som matcher dine valg i filteret. Pr\xf8v igjen med et annet valg."
                            }),
                            currentProducts.length > visibleCount && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-text-center",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cLLe3.default), {
                                    variant: "tertiary",
                                    className: "tw-my-6 [&>svg]:tw-rotate-90",
                                    onClick: ()=>setVisibleCount(visibleCount + 42),
                                    children: "Vis flere produkter"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $15d7eda943b9fd1c$export$2e2bcd8739ae039 = (0, $lp3dk.view)($15d7eda943b9fd1c$var$ProductListPage);

});
parcelRegister("913nc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9ac1ac026805178$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $hA2CZ = parcelRequire("hA2CZ");

var $1Q5Iy = parcelRequire("1Q5Iy");

var $izjX7 = parcelRequire("izjX7");

var $6fuyt = parcelRequire("6fuyt");

var $5OqMf = parcelRequire("5OqMf");

var $bZiDo = parcelRequire("bZiDo");

var $6pY3b = parcelRequire("6pY3b");
const $d9ac1ac026805178$var$CategoryNavigationVertical = ({ categoryInfo: categoryInfo, currentCategoryId: currentCategoryId = "", className: className = "", includeAll: includeAll = false })=>{
    const totalAssortmentProducts = (skus)=>(0, $bZiDo.default).resolveSkus(skus, true).length;
    const linkStyle = (ci)=>{
        const isCurrent = currentCategoryId && ci.id === currentCategoryId || !currentCategoryId && ci.url_key === "produkter";
        return (0, $izjX7.cn)("tw-no-underline", {
            "tw-font-bold": isCurrent
        }, {
            "hover:tw-underline": !isCurrent
        });
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $1Q5Iy.Stack), {
        className: className,
        align: "start",
        justify: "start",
        gap: 1,
        wrap: "nowrap",
        grow: false,
        children: [
            includeAll && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                href: categoryInfo.fullUrl,
                className: linkStyle(categoryInfo),
                trackingLocationName: (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY),
                children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: "Alle produkter"
                })
            }),
            categoryInfo.children.map((child)=>{
                const productCount = totalAssortmentProducts(child.skus);
                return productCount > 0 ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                    href: child.fullUrl,
                    className: linkStyle(child),
                    trackingLocationName: (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY),
                    linkName: child.name,
                    children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        children: [
                            child.catId === "produkter/nyheter" ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hA2CZ.default), {
                                className: "tw-inline tw-ml-[-4px] tw-size-5 tw-pb-1"
                            }) : "",
                            `${(0, $5OqMf.titleCase)(child.name)}`
                        ]
                    })
                }, child.id) : null;
            })
        ]
    });
};
var $d9ac1ac026805178$export$2e2bcd8739ae039 = (0, $lp3dk.view)($d9ac1ac026805178$var$CategoryNavigationVertical);

});

parcelRegister("liXOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894e6666c1026395$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $25aT1 = parcelRequire("25aT1");

var $biFcX = parcelRequire("biFcX");

var $8WkXr = parcelRequire("8WkXr");

var $g12V7 = parcelRequire("g12V7");
const $894e6666c1026395$var$PageNavigation = ({ catInfo: catInfo })=>{
    const { navigationTestVariant: navigationTestVariant } = (0, $biFcX.default);
    const rootCategory = (0, $25aT1.default).categories[0];
    const level1CategoryId = catInfo.levels[1]?.id || "";
    const level2CategoryId = catInfo.levels[2]?.id || "";
    const currentCategoryId = level2CategoryId || level1CategoryId;
    const sideMenuNarrowStyle = "md:tw-hidden";
    const sideMenuWideStyle = "tw-hidden md:tw-block";
    if (navigationTestVariant === "megamenu" || !rootCategory) return null;
    const currentLevel1Category = rootCategory.children?.find((category)=>category.id === currentCategoryId || category.children?.find((level2Category)=>level2Category.id === currentCategoryId));
    const currentLevel2Category = currentLevel1Category?.children?.find((category)=>category.id === currentCategoryId);
    if (navigationTestVariant === "sidemenu") return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: sideMenuNarrowStyle,
                children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8WkXr.CategoryNavigation), {
                    rootCategory: rootCategory,
                    currentLevel1Category: currentLevel1Category,
                    currentLevel2Category: currentLevel2Category
                })
            }),
            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                className: sideMenuWideStyle,
                children: !!currentLevel1Category && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $g12V7.default), {
                    currentLevel1Category: currentLevel1Category,
                    currentLevel2Category: currentLevel2Category
                })
            })
        ]
    });
    if (navigationTestVariant === "topmenu") return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $8WkXr.CategoryNavigation), {
        rootCategory: rootCategory,
        currentLevel1Category: currentLevel1Category,
        currentLevel2Category: currentLevel2Category
    });
    return null;
};
var $894e6666c1026395$export$2e2bcd8739ae039 = (0, $lp3dk.view)($894e6666c1026395$var$PageNavigation);

});
parcelRegister("8WkXr", function(module, exports) {

$parcel$export(module.exports, "CategoryNavigation", function () { return $61d0e170fc50e5c3$export$a6434660d1dfea9; });

var $7YWoO = parcelRequire("7YWoO");

var $hA2CZ = parcelRequire("hA2CZ");

var $95N1g = parcelRequire("95N1g");

var $izjX7 = parcelRequire("izjX7");

var $i4tzf = parcelRequire("i4tzf");

var $8kt8E = parcelRequire("8kt8E");

var $6fuyt = parcelRequire("6fuyt");

var $bZiDo = parcelRequire("bZiDo");

var $g12V7 = parcelRequire("g12V7");
const $61d0e170fc50e5c3$export$a6434660d1dfea9 = ({ currentLevel1Category: currentLevel1Category, currentLevel2Category: currentLevel2Category, rootCategory: rootCategory })=>{
    const [_, navigate] = (0, $8kt8E.useLocation)();
    const hasLevel2 = !!currentLevel1Category?.children?.length;
    const borderOverStyle = "tw-border-t tw-pt-t tw-border-t-ink-border-subtle tw-my-2";
    const level1ClassName = (0, $izjX7.cn)("tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-my-2");
    const narrowClassName = (0, $izjX7.cn)("tw-block md:tw-hidden");
    const wideClassName = (0, $izjX7.cn)("tw-hidden md:tw-block");
    const totalAssortmentProducts = (skus)=>(0, $bZiDo.default).resolveSkus(skus, true).length;
    const className = "tw-text-h4 tw-no-underline hover:tw-underline";
    const level1CategoriesContainingProducts = rootCategory.children.filter((category)=>totalAssortmentProducts(category.skus));
    const level2CategoriesContainingProducts = currentLevel1Category?.children.filter((category)=>totalAssortmentProducts(category.skus)) ?? [];
    const level1Options = [
        {
            label: "Alle",
            value: "",
            id: "Alle"
        },
        ...level1CategoriesContainingProducts.map((category)=>({
                label: category.name,
                value: category.id,
                id: category.id
            }))
    ];
    const level2Options = [
        {
            label: "Alle",
            value: ""
        },
        ...level2CategoriesContainingProducts.map((category)=>({
                label: category.name,
                value: category.id
            }))
    ];
    const level2CurrentOption = level2Options.find((option)=>option.value === currentLevel2Category?.id) ?? level2Options[0];
    const level1CurrentOption = level1Options.find((option)=>option.value === currentLevel1Category?.id) ?? level1Options[0];
    const level2SelectChangeHandler = (option)=>{
        const selectedCategory = currentLevel1Category?.children.find((category)=>category.id === option.value);
        if (selectedCategory) {
            (0, $6fuyt.sendInternalLinkClick)(selectedCategory?.fullUrl, (0, $6fuyt.GA_NAVIGATION_SUB_CATEGORY), selectedCategory.name);
            navigate(selectedCategory.fullUrl);
        } else if (currentLevel1Category) {
            (0, $6fuyt.sendInternalLinkClick)(currentLevel1Category?.fullUrl, (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY), currentLevel1Category.name);
            navigate(currentLevel1Category.fullUrl);
        } else {
            (0, $6fuyt.sendInternalLinkClick)(rootCategory.fullUrl, (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY), rootCategory.name);
            navigate(rootCategory.fullUrl);
        }
    };
    const level1SelectChangeHandler = (option)=>{
        const selectedCategory = rootCategory.children.find((category)=>category.id === option.value);
        if (selectedCategory) {
            (0, $6fuyt.sendInternalLinkClick)(selectedCategory.fullUrl, (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY), selectedCategory.name);
            navigate(selectedCategory.fullUrl);
        } else {
            (0, $6fuyt.sendInternalLinkClick)(rootCategory.fullUrl, (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY), rootCategory.name);
            navigate(rootCategory.fullUrl);
        }
    };
    return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: narrowClassName,
                children: [
                    !!level1CurrentOption && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $i4tzf.Select), {
                        label: "Velg kategori",
                        options: level1Options,
                        value: level1CurrentOption,
                        onChange: level1SelectChangeHandler
                    }),
                    hasLevel2 && !!level2CurrentOption && /*#__PURE__*/ (0, $7YWoO.jsx)((0, $i4tzf.Select), {
                        label: "Velg underkategori",
                        options: level2Options,
                        value: level2CurrentOption,
                        onChange: level2SelectChangeHandler,
                        className: "tw-mt-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                className: wideClassName,
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                        className: level1ClassName,
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $95N1g.default), {
                                url: rootCategory.fullUrl,
                                isActive: !currentLevel1Category,
                                className: className,
                                trackingLocationName: (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY),
                                label: "Alle produkter"
                            }),
                            level1CategoriesContainingProducts.map((category)=>{
                                const label = category.url_key === "nyheter" ? /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                                    className: "tw-flex tw-flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $hA2CZ.default), {}),
                                        category.name
                                    ]
                                }) : category.name;
                                const className = (0, $izjX7.cn)("tw-text-h4 tw-no-underline hover:tw-underline");
                                return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $95N1g.default), {
                                        url: category.fullUrl,
                                        isActive: category.id === currentLevel1Category?.id,
                                        className: className,
                                        trackingLocationName: (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY),
                                        label: label
                                    })
                                }, category.id);
                            })
                        ]
                    }),
                    hasLevel2 && /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: borderOverStyle,
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $g12V7.default), {
                            currentLevel1Category: currentLevel1Category,
                            currentLevel2Category: currentLevel2Category
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("g12V7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d4f36440489e7d$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $6fuyt = parcelRequire("6fuyt");

var $95N1g = parcelRequire("95N1g");
const $25d4f36440489e7d$var$Level2CategoryNavigation = ({ currentLevel1Category: currentLevel1Category, currentLevel2Category: currentLevel2Category, onClick: onClick })=>{
    const hasLevel2 = !!currentLevel1Category.children?.length;
    if (!hasLevel2) return null;
    return /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
        className: "tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-my-2",
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $95N1g.default), {
                url: currentLevel1Category?.fullUrl,
                isActive: !currentLevel2Category,
                className: "tw-text-h4",
                label: `Alle ${currentLevel1Category?.name?.toLowerCase()}`,
                onClick: onClick,
                trackingLocationName: (0, $6fuyt.GA_NAVIGATION_MAIN_CATEGORY),
                invertedHover: true
            }),
            currentLevel1Category?.children?.map((category)=>{
                return /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $95N1g.default), {
                        url: category.fullUrl,
                        isActive: category.id === currentLevel2Category?.id,
                        className: "tw-text-h4",
                        label: category.name,
                        onClick: onClick,
                        trackingLocationName: (0, $6fuyt.GA_NAVIGATION_SUB_CATEGORY),
                        invertedHover: true
                    })
                }, category.id);
            })
        ]
    });
};
var $25d4f36440489e7d$export$2e2bcd8739ae039 = $25d4f36440489e7d$var$Level2CategoryNavigation;

});





//# sourceMappingURL=ProductListPage.7c8eedc3.js.map
